const months = require('../data/months.json');

function getDateString(date) {
  const articleDate = new Date(date);
  const month = months[articleDate.getMonth()];
  const day = articleDate.getDate();
  const year = articleDate.getFullYear();
  return `${month} ${day}, ${year}`;
}
function formatDate(dateStr) {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dev'
  ];

  const date = new Date(dateStr);

  return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
}

function qualityColor(score) {
  if (score <= 44) {
    return 'redscore';
  }
  if (score > 44 && score <= 60) {
    return 'orangescore';
  }
  if (score > 60 && score <= 74) {
    return 'yellowscore';
  }
  if (score > 74 && score <= 89) {
    return 'olivescore';
  }
  if (score > 89 && score <= 100) {
    return 'greenscore';
  }
  return 'olivescore';
}

function numberWithCommas(x) {
  return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function numberKorM(number) {
  if (number.toFixed(0).toString().length > 6) {
    return `${(number / 1000000).toFixed(1)}M`.replace('.0', '');
  } if (number.toFixed(0).toString().length > 3) {
    return `${(number / 1000).toFixed(1)}K`.replace('.0', '');
  }
  return number;
}

module.exports = {
  getDateString,
  formatDate,
  qualityColor,
  numberWithCommas,
  numberKorM
};
